import { StatusVocabulary, TypeCodes } from 'constants/data'

//
const A_ARTICLE_SCROLL = 'article_scroll'
const A_CLINIC_SCROLL = 'clinic_scroll'
const A_INTRO_SCROLL = 'intro_scroll'
const A_MAIN_SCROLL = 'main_scroll'
const A_COURSE_SCROLL = 'program_scroll'
const A_SHARE_OPEN = 'share_open'
const A_SHARE_CLICK = 'share_click'
const A_TOGGLE_SELECT = 'feed_selected'
const A_LIKE_CLICK_TRUE = 'like_click_true'
const A_LIKE_CLICK_FALSE = 'like_click_false'
///

const A_ELIDEL_SCROLL = 'elidel_scroll'
const A_ELIDEL_MATERIALS_CLICK = 'elidel_click_materials_button'
const A_ELIDEL_CLINCASE_CLICK = 'elidel_click_clin_button'
const A_ELIDEL_MEMO_CLICK = 'elidel_click_memo_button'
const A_ELIDEL_VIDEO_CLICK = 'elidel_click_video_button'
const A_ELIDEL_COMIC_CLICK = 'elidel_click_comic_button'
const A_ELIDEL_REG_CLICK = 'elidel_registration_click'

const A_DONA_SCROLL = 'dona_scroll'
const A_DONA_MATERIALS_CLICK = 'dona_click_materials_button'
const A_DONA_CLINCASE_CLICK = 'dona_click_clin_button'
const A_DONA_REG_CLICK = 'dona_registration_click'

const A_VIATRIS_CARDIO_SCROLL = 'kardio_scroll'
const A_VIATRIS_CARDIO_VIDEO = 'kardio_click_video_button'
const A_VIATRIS_CARDIO_BTN_MORE = 'kardio_click_strat_button'
const A_VIATRIS_CERTIFICATE = 'kardio_click_certificate'
const A_VIATRIS_QUESTION = 'kardio_click_question'

const PLACEFLAG_MAIN = 'main'
const PLACEFLAG_CHAT = 'webinar_chat'
const PLACEFLAG_LIVE = 'webinar_live'
const PLACEFLAG_LIVE_END = 'webinar_live_end'
const PLACEFLAG_PAST = 'webinar_past'
const PLACEFLAG_FUTURE = 'webinar_future'
const PLACEFLAG_FUTURE_RECOMMENDATION = 'webinar_future_recommendation'
const PLACEFLAG_PAST_RECOMMENDATION = 'webinar_past_recommendation'
const PLACEFLAG_HOUR_BEFORE = 'webinar_hour_before'
const PLACEFLAG_SEARCH = 'webinar_search'
const PLACEFLAG_COMMENT = 'comment'
const PLACEFLAG_VIDEO = 'video'
const PLACEFLAG_ARTICLE = 'article'
const PLACEFLAG_CLINIC = 'clinic'
const PLACEFLAG_PODCAST = 'podcast'
const PLACEFLAG_LIBRARY = 'library'
const PLACEFLAG_LECTOR_PERSONAL = 'lectur_personalpage'
const PLACEFLAG_LECTOR_LIST = 'lectur_list'
const PLACEFLAG_EMAIL = 'email'
const PLACEFLAG_EMAIL_CONFIRM = 'email_confirm'
const PLACEFLAG_BANNER = 'banner'
const PLACEFLAG_NMO_FAQ = 'nmo_faq'
const PLACEFLAG_HOW_TO_GET_NMO = 'how_to_get'
const PLACEFLAG_HOW_TO_GET_FIFTY_NMO = 'how_to_get_fifty'
const PLACEFLAG_ACTIVATE_NMO = 'activate'
const PLACEFLAG_BACKEND = 'automat'
const PLACEFLAG_PROFILE = 'profile'
const PLACEFLAG_QUESTIONNAIRE = 'questionnaire'
const PLACEFLAG_CROWDFUNDING = 'crowdfunding'
const PLACEFLAG_COURSE = 'course'
const PLACEFLAG_COURSE_TAB = 'course_tab'
const PLACEFLAG_CLINIC_CASE_TAB = 'clinic_case_tab'
const PLACEFLAG_CLINIC_CASE = 'clinic_case'
const PLACEFLAG_GAME = 'game'
const PLACEFLAG_COURSE_CARDIO = 'cardio_course'
const PLACEFLAG_CARDIO = 'cardio'
const PLACEFLAG_CARDIO_START_PAGE = 'cardio_start_page'
const PLACEFLAG_CARDIO_MEDIUM_PAGE = 'cardio_medium_page'
const PLACEFLAG_CARDIO_END_PAGE = 'cardio_end_page'
const PLACEFLAG_CARDIO_NMO = 'cardio_nmo'
const PLACEFLAG_MINICARDIO = 'cardio18'
const PLACEFLAG_MINICARDIO_START_PAGE = 'cardio18_start_page'
const PLACEFLAG_MINICARDIO_MEDIUM_PAGE = 'cardio18_medium_page'
const PLACEFLAG_MINICARDIO_END_PAGE = 'cardio18_end_page'
const PLACEFLAG_MINICARDIO_NMO = 'cardio18_nmo'
const PLACEFLAG_OSTEO_NMO = 'osteo_middle_page'
const PLACEFLAG_OSTEO_START_PAGE = 'osteo_start_page'
const PLACEFLAG_OSTEO_MIDDLE_PAGE = 'osteo_middle_page'
const PLACEFLAG_OSTEO_END_PAGE = 'osteo_end_page'
const PLACEFLAG_OSTEO_END = 'osteo_end'
const PLACEFLAG_NEURO = 'neuro'
const PLACEFLAG_NEURO_START_PAGE = 'neuro_start_page'
const PLACEFLAG_NEURO_MIDDLE_PAGE = 'neuro_middle_page'
const PLACEFLAG_NEURO_END_PAGE = 'neuro_end_page'
const PLACEFLAG_GERIATRICS = 'geriatrics'
const PLACEFLAG_GERIATR_START_PAGE = 'geriatr_start_page'
const PLACEFLAG_GERIATR_MIDDLE_PAGE = 'geriatr_middle_page'
const PLACEFLAG_GERIATR_END_PAGE = 'geriatr_end_page'
const PLACEFLAG_GERIATRICS_BASIC = 'geriatrics18'
const PLACEFLAG_GERIATR_BASIC_START_PAGE = 'geriatr18_start_page'
const PLACEFLAG_GERIATR_BASIC_MIDDLE_PAGE = 'geriatr18_middle_page'
const PLACEFLAG_GERIATR_BASIC_END_PAGE = 'geriatr18_end_page'
const PLACEFLAG_VIDEO_PROJECT = 'video_project'
const PLACEFLAG_SOMNOLOGY_START_PAGE = 'somnology_start_page'
const PLACEFLAG_SOMNOLOGY_MIDDLE_PAGE = 'somnology_middle_page'
const PLACEFLAG_SOMNOLOGY_MIDDLE_PAGE_2 = 'somnology_middle_page_2'
const PLACEFLAG_SOMNOLOGY_END_PAGE = 'somnology_end_page'
const PLACEFLAG_SOMNOLOGY = 'somnology'
const PLACEFLAG_GASTROINTESTINAL = 'gastrointestinal_diseases'
const PLACEFLAG_GASTROINTESTINAL_START_PAGE = 'gastrointestinal_diseases_start_page'
const PLACEFLAG_GASTROINTESTINAL_END_PAGE = 'gastrointestinal_diseases_end_page'
const PLACEFLAG_GASTROINTESTINAL_MIDDLE_PAGE = 'gastrointestinal_diseases_middle_page'
const PLACEFLAG_PROGRAM_START_PAGE = 'program_start_page'
const PLACEFLAG_PROGRAM_MIDDLE_PAGE = 'program_middle_page'
const PLACEFLAG_PROGRAM_END_PAGE = 'program_end_page'

const AnalyticWebinarPlace = {
  [StatusVocabulary.FUTURE]: PLACEFLAG_FUTURE,
  [StatusVocabulary.HOUR_BEFORE]: PLACEFLAG_HOUR_BEFORE,
  [StatusVocabulary.ACTIVE]: PLACEFLAG_LIVE,
  [StatusVocabulary.PAST]: PLACEFLAG_PAST,
}

const AnalyticArticlePlace = {
  [TypeCodes.ARTICLE]: PLACEFLAG_ARTICLE,
  [TypeCodes.CLINIC]: PLACEFLAG_CLINIC,
  [TypeCodes.VIDEO]: PLACEFLAG_VIDEO,
}

const WithoutCampaignQuery = [PLACEFLAG_FUTURE, PLACEFLAG_CLINIC]

export {
  A_ARTICLE_SCROLL,
  A_CLINIC_SCROLL,
  A_INTRO_SCROLL,
  A_MAIN_SCROLL,
  A_COURSE_SCROLL,
  PLACEFLAG_MAIN,
  PLACEFLAG_CHAT,
  PLACEFLAG_LIVE,
  PLACEFLAG_FUTURE,
  PLACEFLAG_FUTURE_RECOMMENDATION,
  PLACEFLAG_PAST_RECOMMENDATION,
  PLACEFLAG_COMMENT,
  PLACEFLAG_BANNER,
  PLACEFLAG_NMO_FAQ,
  PLACEFLAG_HOW_TO_GET_NMO,
  PLACEFLAG_HOW_TO_GET_FIFTY_NMO,
  PLACEFLAG_ACTIVATE_NMO,
  PLACEFLAG_QUESTIONNAIRE,
  PLACEFLAG_PAST,
  PLACEFLAG_LECTOR_PERSONAL,
  PLACEFLAG_LECTOR_LIST,
  PLACEFLAG_EMAIL,
  PLACEFLAG_ARTICLE,
  PLACEFLAG_VIDEO,
  PLACEFLAG_SEARCH,
  PLACEFLAG_EMAIL_CONFIRM,
  PLACEFLAG_LIVE_END,
  PLACEFLAG_BACKEND,
  PLACEFLAG_PROFILE,
  PLACEFLAG_CROWDFUNDING,
  PLACEFLAG_LIBRARY,
  PLACEFLAG_COURSE,
  PLACEFLAG_CLINIC_CASE,
  PLACEFLAG_CLINIC_CASE_TAB,
  PLACEFLAG_COURSE_TAB,
  PLACEFLAG_GAME,
  PLACEFLAG_PODCAST,
  PLACEFLAG_COURSE_CARDIO,
  PLACEFLAG_CARDIO,
  PLACEFLAG_CARDIO_START_PAGE,
  PLACEFLAG_CARDIO_MEDIUM_PAGE,
  PLACEFLAG_CARDIO_END_PAGE,
  PLACEFLAG_CARDIO_NMO,
  PLACEFLAG_MINICARDIO,
  PLACEFLAG_MINICARDIO_START_PAGE,
  PLACEFLAG_MINICARDIO_MEDIUM_PAGE,
  PLACEFLAG_MINICARDIO_END_PAGE,
  PLACEFLAG_MINICARDIO_NMO,
  PLACEFLAG_NEURO,
  PLACEFLAG_NEURO_START_PAGE,
  PLACEFLAG_NEURO_MIDDLE_PAGE,
  PLACEFLAG_NEURO_END_PAGE,
  PLACEFLAG_GERIATRICS,
  PLACEFLAG_GERIATR_START_PAGE,
  PLACEFLAG_GERIATR_MIDDLE_PAGE,
  PLACEFLAG_GERIATR_END_PAGE,
  PLACEFLAG_GERIATRICS_BASIC,
  PLACEFLAG_GERIATR_BASIC_START_PAGE,
  PLACEFLAG_GERIATR_BASIC_MIDDLE_PAGE,
  PLACEFLAG_GERIATR_BASIC_END_PAGE,
  PLACEFLAG_VIDEO_PROJECT,
  PLACEFLAG_OSTEO_NMO,
  PLACEFLAG_OSTEO_START_PAGE,
  PLACEFLAG_OSTEO_MIDDLE_PAGE,
  PLACEFLAG_OSTEO_END_PAGE,
  PLACEFLAG_OSTEO_END,
  PLACEFLAG_SOMNOLOGY_START_PAGE,
  PLACEFLAG_SOMNOLOGY_MIDDLE_PAGE,
  PLACEFLAG_SOMNOLOGY_MIDDLE_PAGE_2,
  PLACEFLAG_SOMNOLOGY_END_PAGE,
  PLACEFLAG_SOMNOLOGY,
  PLACEFLAG_GASTROINTESTINAL,
  PLACEFLAG_GASTROINTESTINAL_START_PAGE,
  PLACEFLAG_GASTROINTESTINAL_MIDDLE_PAGE,
  PLACEFLAG_GASTROINTESTINAL_END_PAGE,
  A_SHARE_OPEN,
  A_SHARE_CLICK,
  A_LIKE_CLICK_TRUE,
  A_LIKE_CLICK_FALSE,
  A_TOGGLE_SELECT,
  AnalyticWebinarPlace,
  AnalyticArticlePlace,
  PLACEFLAG_PROGRAM_START_PAGE,
  PLACEFLAG_PROGRAM_MIDDLE_PAGE,
  PLACEFLAG_PROGRAM_END_PAGE,
  A_ELIDEL_SCROLL,
  A_ELIDEL_MATERIALS_CLICK,
  A_ELIDEL_CLINCASE_CLICK,
  A_ELIDEL_MEMO_CLICK,
  A_ELIDEL_VIDEO_CLICK,
  A_ELIDEL_COMIC_CLICK,
  A_ELIDEL_REG_CLICK,
  A_VIATRIS_CARDIO_SCROLL,
  A_VIATRIS_CARDIO_VIDEO,
  A_VIATRIS_CARDIO_BTN_MORE,
  A_VIATRIS_CERTIFICATE,
  A_VIATRIS_QUESTION,
  A_DONA_SCROLL,
  A_DONA_MATERIALS_CLICK,
  A_DONA_CLINCASE_CLICK,
  A_DONA_REG_CLICK,
  //
  WithoutCampaignQuery,
}
